import React, { useState } from 'react';
import { Table, Button, Card, Collapse, Form, Row, Col } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash, FaPen, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridEtapas = ({ codigoFamilia, etapas, etapasEmpreendimento, permissoes, onRecarregar }) => {
  const [aberto, setAberto] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formSeq, setFormSeq] = useState('');
  const [formAndamento, setFormAndamento] = useState('');
  const [formCodigoEtapa, setFormCodigoEtapa] = useState('');
  const [formDescricao, setFormDescricao] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleAdicionarEtapa = (etapa) => {
    const maxSeq = etapasEmpreendimento.length > 0
      ? Math.max(...etapasEmpreendimento.map((e) => e.seq)) + 1
      : 1;
    setFormCodigoEtapa(String(etapa.codigo_etapa));
    setFormDescricao(etapa.descricao);
    setFormSeq(String(maxSeq));
    setFormAndamento('');
    setEditando(null);
    setShowForm(true);
  };

  const handleEditarEtapa = (item) => {
    setFormCodigoEtapa(String(item.codigo_etapa));
    setFormDescricao(item.descricao);
    setFormSeq(String(item.seq));
    setFormAndamento(item.andamento != null ? String(item.andamento) : '');
    setEditando(item.codigo_etapa);
    setShowForm(true);
  };

  const handleSalvar = async () => {
    if (formSeq === '' || Number(formSeq) <= 0) {
      toast.error('Sequência inválida.');
      return;
    }
    setSalvando(true);
    try {
      const dados = {
        codigo_familia: codigoFamilia,
        codigo_etapa: Number(formCodigoEtapa),
        seq: Number(formSeq),
        andamento: formAndamento !== '' ? Number(formAndamento) : null,
      };
      if (editando != null) {
        await api.alterarEtapaConfig(dados);
        toast.success('Etapa alterada com sucesso!');
      } else {
        await api.incluirEtapaConfig(dados);
        toast.success('Etapa incluída com sucesso!');
      }
      setShowForm(false);
      setEditando(null);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar etapa';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir a etapa "${item.descricao}"?`)) return;
    try {
      await api.excluirEtapaConfig({
        codigo_familia: codigoFamilia,
        codigo_etapa: item.codigo_etapa,
      });
      toast.success('Etapa excluída!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir etapa';
      toast.error(msg);
    }
  };

  const etapasDisponiveis = etapas.filter(
    (et) => !etapasEmpreendimento.some((ee) => ee.codigo_etapa === et.codigo_etapa)
  );

  return (
    <Card className="mb-3">
      <Card.Header
        className="d-flex justify-content-between align-items-center py-2"
        style={{ cursor: 'pointer' }}
        onClick={() => setAberto(!aberto)}
      >
        <strong>
          {aberto ? <FaChevronDown size={12} className="mr-2" /> : <FaChevronRight size={12} className="mr-2" />}
          Etapas
        </strong>
        <span className="text-muted small">{etapasEmpreendimento.length} vinculada(s)</span>
      </Card.Header>
      <Collapse in={aberto}>
        <Card.Body className="p-0">
          {/* Grid Etapas do Empreendimento */}
          <div className="p-2">
            <h6 className="mb-2">Etapas do Empreendimento</h6>
            {showForm && (
              <div className="p-3 mb-2 border rounded bg-light">
                <Row>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Etapa</Form.Label>
                      <Form.Control value={`${formCodigoEtapa} - ${formDescricao}`} disabled />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Sequência *</Form.Label>
                      <Form.Control type="number" value={formSeq} onChange={(e) => setFormSeq(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Andamento (%)</Form.Label>
                      <Form.Control type="number" step="0.01" value={formAndamento} onChange={(e) => setFormAndamento(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <Button size="sm" variant="success" className="mr-2" onClick={handleSalvar} disabled={salvando}>
                      <FaSave className="mr-1" /> Salvar
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => { setShowForm(false); setEditando(null); }} disabled={salvando}>
                      <FaTimes className="mr-1" /> Cancelar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <Table striped bordered hover size="sm" className="mb-3">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Seq</th>
                  <th>Etapa</th>
                  <th>Descrição</th>
                  <th style={{ width: 120 }}>Andamento (%)</th>
                  <th style={{ width: 120 }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {etapasEmpreendimento.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center text-muted">Nenhuma etapa vinculada</td>
                  </tr>
                )}
                {etapasEmpreendimento.map((item) => (
                  <tr key={item.codigo_etapa}>
                    <td>{item.seq}</td>
                    <td>{item.codigo_etapa}</td>
                    <td>{item.descricao}</td>
                    <td>{item.andamento != null ? item.andamento : '-'}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      {permissoes.projeto && (
                        <>
                          <Button size="sm" variant="outline-primary" className="mr-1" title="Alterar" onClick={() => handleEditarEtapa(item)}>
                            <FaPen />
                          </Button>
                          <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                            <FaTrash />
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>

            {/* Grid Etapas Disponíveis */}
            <h6 className="mb-2">Etapas Disponíveis</h6>
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Código</th>
                  <th>Descrição</th>
                  <th style={{ width: 80 }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {etapasDisponiveis.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center text-muted">Todas as etapas já foram vinculadas</td>
                  </tr>
                )}
                {etapasDisponiveis.map((et) => (
                  <tr key={et.codigo_etapa}>
                    <td>{et.codigo_etapa}</td>
                    <td>{et.descricao}</td>
                    <td>
                      {permissoes.projeto && (
                        <Button size="sm" variant="outline-success" title="Adicionar" onClick={() => handleAdicionarEtapa(et)}>
                          <FaPlus />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>
          </div>
        </Card.Body>
      </Collapse>
    </Card>
  );
};

export default GridEtapas;
